<template>
  <div class="mine page">
    <div class="bg-container page-bg" :style="{ 'background-image': `url(${$store.getters.getBaseInfo.center_bg})` }">
      <div class="bg-wrapper"></div>
    </div>

    <!-- <div class="page-bg"></div> -->
    <div class="wrapper">
      <div class="header">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="setting-o" @click="showSetting()" color="#fff" />
          </template>
        </van-nav-bar>
        <div class="user-wrapper" @click="doLogin()">
          <van-image round class="user_img" :src="this.userInfo.header_img">
            <template v-slot:loading>
              <van-loading type="spinner" />
            </template>
          </van-image>
          <div class="login-content">
            <p class="login-btn">{{ this.userInfo.username }}
              <img class="login-vip" v-if="this.userInfo && this.userInfo.groupinfo"
                :src="this.userInfo.groupinfo.image" alt="">
            </p>
            <p class="login-label" v-if="this.userInfo && this.userInfo.groupinfo">
              <van-progress :percentage="this.userInfo.groupinfo.rate" :show-pivot="false" stroke-width="8px"
                color="#ffabb2" />
            </p>
          </div>
          <!-- <img style="width: 30px;" src="img/mine/qrcode.svg" alt=""> -->
        </div>
      </div>
      <div class="content">
        <div class="finance">
          <div class="finance-item">
            <div>

              <div>{{ $t('账户积分') }}</div>
              <div class="text">{{ this.userInfo.money || 0 }}</div>
            </div>
          </div>
          <div class="finance-item">
            <!-- <van-icon class="icon" name="idcard" /> -->
            <div>

              <div>{{ $t('信誉分') }}</div>
              <div class="text">{{ this.userInfo.point || 0 }}</div>

            </div>
          </div>
          <!-- <div class="finance-item">
            <div>

              <div>{{ $t('观影次数') }}</div>
              <div class="text">{{ this.userInfo.see_total || 0 }}</div>
            </div>
          </div> -->
        </div>
        <div class="vip_group">
          <!-- <div class="vip_group_txt">{{$t('Vip_txt')}}</div>
          <img class="vip_group_img" src="/img/vip.png" alt=""> -->
        </div>
        <!-- <div class="wallet">
            <div class="part-1 van-hairline--bottom" @click="$router.push({ path: '/Moneylog' });">
              <p class="flex-1 font-28 font-primary-color">{{ $t("my.my_balance") }}</p>
              <van-button type="primary" class="refresh-btn">{{ $t('my.refresh') }}</van-button>
            </div>
            <div class="part-2">
              <p class="balance van-ellipsis">{{ this.userInfo.money }}</p>
              <span class="font-28 font-gray">{{ $t("reservation.unit") }}</span>
            </div>

            <div class="part-2">
              <p class="balance van-ellipsis">{{ this.userInfo.point }}</p>
              <span class="font-28 font-gray"> {{ $t("my.point") }}</span>
            </div>
          </div> -->
        <van-cell-group class="mine-cell" inset>
          <van-cell is-link @click="doWithdrawal()">
            <template #title>
              <img src="/img/mine/zijin.png?t=7" alt="" srcset="">
              <span class="custom-title">{{ $t('my.withdraw') }}</span>
            </template>
          </van-cell>
          <!-- <van-cell is-link @click="doPay()">
            <template #title>
              <img src="/img/mine/txzx.png?t=7" alt="" srcset="">
              <span class="custom-title">{{ $t('my.recharge') }}</span>
            </template>
          </van-cell>
          <van-cell is-link @click="$router.push({ path: '/Infomation' });">
            <template #title>
              <img src="/img/mine/zhzl.png?t=7" alt="" srcset="">
              <span class="custom-title">{{ $t('my.personal_center') }}</span>
            </template>
          </van-cell> -->
          
          <van-cell is-link @click="$router.push({ path: '/WithdrawRecord' });">
            <template #title>
              <img src="/img/mine/duihuan.png?t=7" alt="" srcset="">
              <span class="custom-title">{{ $t('withdraw.with_record') }}</span>
            </template>
          </van-cell>
          <van-cell is-link @click="$router.push({ path: '/Moneylog' });">
            <template #title>
              <img src="/img/mine/jifen.png?t=7" alt="" srcset="">
              <span class="custom-title">{{ $t('my.account_detail') }}</span>
            </template>
          </van-cell>
          <van-cell is-link @click="$router.push({ path: '/GameRecord' });">
            <template #title>
              <img src="/img/mine/toupiao.png?t=7" alt="" srcset="">
              <span class="custom-title">{{ $t('my.task_record') }}</span>
            </template>
          </van-cell>
          <!-- <van-cell is-link @click="$router.push({ path: '/GameRecord' });">
            <template #title>
              <img src="/img/mine/youxijilu.png" alt="" srcset="">
              <span class="custom-title">{{ $t('my.task_record') }}</span>
            </template>
          </van-cell> -->
          <!-- <van-cell is-link @click="$router.push({ path: '/Notice' });">
            <template #title>
              <img src="/img/mine/gonggao1.png?t=7" alt="" srcset="">
              <span class="custom-title">{{ $t('my.sys_notice') }}</span>
            </template>
          </van-cell> -->
          <!-- <van-cell is-link @click="$router.push({ path: '/Setbank' });">
            <template #title>
              <img src="/img/mine/duihuan.png" alt="" srcset="">
              <span class="custom-title">{{ $t('setting.bank_info') }}</span>
            </template>
          </van-cell> -->

        </van-cell-group>
        
      <van-button class="sign-out" v-if="token"  type="primary" size="normal" @click="loginout()">{{$t("setting.logout")}}</van-button>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      userInfo: {
      },
      menu_top: 80,
      isLoading: false,
      token:localStorage.getItem('token')
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          // this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Setting' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Notice' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          // this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        // this.$router.push({ path: '/Infomation' });
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    doPay() {
      this.$router.push({
        name: 'Recharge',
        params: {
          'balance': this.userInfo.money
        }
      })
    },
    doWithdrawal() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      })
    },
    toWithdrawRecord() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/withdrawRecord' });
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    loginout() {
      localStorage.clear()
      this.$router.push({ path: '/Login' });
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
}

.mine {
  position: relative;
  bottom: 10px;
  background: #ffffff;
}

.mine .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 180px;
}

.nav-bar {
  background: none;
}

.mine .header {
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
  /* background-image: url('/img/mine/header.png'); */
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100px;
}

.mine .page-bg {
  height: 500px;
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
  z-index: 0;
  background-size: cover;

}
::v-deep .van-nav-bar__content {
  height: 100px;
}

.mine .header .van-nav-bar .van-icon {
  font-size: 45px;
}

.mine .header .user-wrapper {
  display: flex;
  align-items: center;
  margin: 0px 40px 0px 40px;

}

.mine .user_img {
  height: 130px;
  width: 130px;
}

::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}

::v-deep .van-image__error-icon {
  font-size: 70px;
}

.mine .header .user-wrapper .login-content {
  flex: 1;
  margin-left: 30px;
}

.mine .header .user-wrapper .login-content .login-btn {
  display: inline-block;
  font-size: 40px;
  line-height: 0px;
  color: #ffffff;
  display: flex;
  align-items: center;
}

.mine .header .user-wrapper .login-content .login-label {
  /* margin-top: -13px; */
  width: 60%;
  font-size: 28px;
  color: hsla(0, 0%, 100%, .6);

}


.mine .content {
  position: relative;
  padding: 10px 30px 30px;
  min-height: 500px;
  background-color: #ffffff;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #ffffff;
  font-size: 35px;
}

.mine .wrapper .content .finance {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  left: 30px;
  right: 30px;
  height: 160px;
  border-radius: 15px;
  box-shadow: 0 0 8px 0vw #e4e4e7;
  background: #ffffff;

}

.mine .wrapper .content .finance .line {
  width: 3px;
  height: 40px;
  background-color: #ccc;
}

.mine .wrapper .content .finance .finance-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 32px;
}

.mine .wrapper .content .finance .finance-item .text {
  font-size: 36px;
  color: #d1af6f;
  font-weight: 500;
  margin-top: 10px;
  text-align: center;
}

.mine .wrapper .content .finance .finance-item .icon {
  /* font-size: 50px; */
  width: 80px;
}

.mine .wrapper .content .menu {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-radius: 15px;
  box-shadow: 0 0 8px 0vw #e4e4e7;
}

.mine .wrapper .content .menu .menu-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 50%;
  height: 130px;
}

.mine .wrapper .content .menu .menu-item .menu-item-label {
  font-size: 30px;
  color: #d1af6f;
  font-weight: 500;
}

.mine .wrapper .content .menu .menu-item .menu-item-icon {
  margin: 25px;
  width: 80px;
  height: 80px;
  -o-object-fit: contain;
  object-fit: contain;
}

.mine .wrapper .content .wallet {
  margin-top: 80px;
  padding: 0 30px;
  border-radius: 15px;
  box-shadow: 0 0 8px 0vw #e4e4e7;
}

.mine .wrapper .content .wallet .part-1 {
  display: flex;
  align-items: center;
  height: 100px;
}

.mine .wrapper .content .wallet .font-primary-color {
  color: #d1af6f;
}

.font-gray {
  color: #d1af6f;
}

.mine .wrapper .content .wallet .part-2 {
  display: flex;
  align-items: center;
  height: 150px;
}

.mine .wrapper .content .wallet .part-2 .balance {
  flex: 1;
  font-size: 60px;
  color: #d1af6f;
  font-weight: 700;
}

::v-deep .mine .wrapper .content .wallet .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

.mine .wrapper .content .refresh-btn {
  /* margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 30px;
  border-radius: 50%; */
  color: #ffffff;
  border: none;
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
  padding: 20px;
  color: #ffffff;
  font-weight: 700;
  font-size: 24px;
  border-radius: 10px;
}

.login-vip {
  width: 142px;
  height: 45px;
  margin-left: 0px;
  margin-bottom: -12px;
}

::v-deep .van-cell {
  padding: 30px 22px;
  font-size: 30px;
  line-height: 30px;
}

.mine-cell img {
  width: 50px;
  margin-right: 10px;
}

.mine-cell .van-cell__title {
  display: flex;
  align-items: center;
}


.vip_group{
  
  display: flex;
  align-items: center;
  /* border-radius: 15px; */
  box-shadow: 0 0 8px 0vw #e4e4e7;
  background: #ffffff;
  margin-top: 120px;
  height: 180px;
  padding: 30px 60px;
  justify-content: center;
  border-radius: 100px;
  color: #ffffff;
  margin-bottom: 30px;
  background: linear-gradient(120deg, #d1af6f, #d1af6f);
  background-image: url('/img/mine/btn.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.vip_group_txt{
  width: 80%;
}
.vip_group_img{
  width: 150px;
}
.sign-out{
  margin: 60px auto 0;
  height: 100px;
  line-height: 100px;
  border-radius: 50px;
  width: 90%;
  color: #ffffff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg, #d1af6f, #d1af6f);
}
</style>
